import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OrderOutput } from 'core/http/project';
import { ownedError } from 'core/utils/owned-error';

type PrettyOrder = OrderOutput & { storehouseName: string };

@Component({
  selector: 'app-storehouse-view',
  templateUrl: './storehouse-view.component.html',
  styleUrls: ['./storehouse-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StorehouseViewComponent {
  private _order?: PrettyOrder;

  @Input() skeletonView = false;

  @Input()
  set order(o: PrettyOrder) {
    this._order = o;
  }

  get order(): PrettyOrder {
    if (!this._order) {
      throw ownedError(new Error('Order was not initialized'));
    }

    return this._order;
  }

  constructor() { }
}
